import { Component, OnInit } from '@angular/core';
import {timeInterval} from '../time.model';


@Component({
  selector: 'contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.sass']
})
export class ContactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  getTimeInterval(){
    return timeInterval;
  }

  disableGoogleAnalytic(){
    window['ga-disable-UA-168766260-1'] = true;
  }

}
